import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Kit Express PRO: Sesión Perfecta en 10 Min',
  desc: '6 plantillas copy/paste con objetivos, evidencia y cierre.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Scripts PRO para Familias',
  desc: '80 mensajes de WhatsApp listos para adherencia y seguimiento.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Evolución & Reportes 360',
  desc: 'Trackers mensuales + informe familia + informe equipo + alta.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Actividades SOS de Consultorio',
  desc: '24 fichas listas con objetivo, pasos y cierre. Para días sin tiempo.',
  price: '$9.000'
}, {
  num: '05',
  title: 'Consultorio 360: Setup PRO',
  desc: 'Plano por zonas + checklists + lista low-cost + rotación semanal.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Situaciones Difíciles en Sesión',
  desc: '25 casos reales resueltos: qué hacer, qué decir, qué mandar a casa.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 py-10 text-gray-900" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-42">
      <div className="mx-auto max-w-3xl" data-id="element-43">

        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-44">
          Más los{' '}
          <span className="text-cyan-brand" data-id="element-45">6 Bonos Estratégicos</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-46">
          Incluidos en todas las ofertas — sin costo extra
        </p>

        {/* Bonus List */}
        <div className="bg-white border border-cyan-brand/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-47">

          {/* Header */}
          <div className="bg-cyan-brand px-5 py-3" data-id="element-48">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-49">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>

          {/* List */}
          <div className="divide-y divide-gray-100" data-id="element-50">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-3" data-id="element-51">
                {/* Número */}
                <span className="shrink-0 text-lg font-black text-cyan-brand/30 w-8 text-center" data-id="element-52">
                  {bonus.num}
                </span>

                {/* Contenido */}
                <div className="flex-1 min-w-0" data-id="element-53">
                  <span className="block text-sm font-black text-gray-900" data-id="element-54">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-55">
                    {bonus.desc}
                  </span>
                </div>

                {/* Precio tachado + GRATIS */}
                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-56">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-57">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white bg-cyan-brand rounded-full px-2 py-0.5" data-id="element-58">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total Value Footer */}
        <div className="text-center rounded-xl px-5 py-4 shadow-sm" style={{
        backgroundColor: 'rgb(240, 249, 255)',
        border: '1px solid rgba(0, 180, 216, 0.3)'
      }} data-id="element-59">
          <p className="text-xs font-bold uppercase tracking-widest text-cyan-brand m-0 mb-1" data-id="element-60">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-61">
            <span className="text-base text-gray-400 line-through" data-id="element-62">
              $58.000
            </span>
            <span className="text-lg font-black text-cyan-brand" data-id="element-63">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>

      </div>
    </section>;
}